import type { NavigationScreen } from 'app/types/navigation';
import { useUISize } from 'app/utils/web-helpers';
import { PersonalInformationScreen as PersonalInformationScreenLarge } from './personal-information.large';
import { PersonalInformationScreen as PersonalInformationScreenSmall } from './personal-information.small';

export const PersonalInformationScreen: NavigationScreen<'personal-information'> = (props) => {
  const { isSmallUI } = useUISize();

  if (!isSmallUI) {
    return <PersonalInformationScreenLarge {...props} />;
  }
  return <PersonalInformationScreenSmall {...props} />;
};
